import { styled, component } from '../../utils/style';
import { Format, StyleColor } from '../../utils/styles-constants';
import { DriveItemListDisplayType } from '../DriveItemList/constants';

const DriveItemContainer = styled()(component.div, 'DriveItemContainer')``;
export const DriveItemContainerVariants: ({}) = {
	[DriveItemListDisplayType.Grid]: DriveItemContainer.extend`
		width: 100%;

		@media ${Format.SmartphoneLandscape}, ${Format.Tablet} {
			width: 50%;
		}

		@media ${Format.SmallDesktop} {
			width: 33.3%;
		}

		@media ${Format.LargeDesktop} {
			width: 25%;
		}
	`,
	[DriveItemListDisplayType.Row]: DriveItemContainer.extend`
		width: 100%;

		@media ${Format.Tablet}, ${Format.SmallDesktop} {
			width: 50%;
		}

		@media ${Format.LargeDesktop} {
			width: 33.3%;
		}
	`,
	[DriveItemListDisplayType.Masonry]: DriveItemContainer.extend`
		width: 100%;
	`
};


const DriveItem = styled()(component.div, 'DriveItem')`
	cursor: pointer;
`;

const driveItemBlockStyle = `
	position relative;
	background: ${StyleColor.White};
	overflow: hidden;
	box-sizing: border-box;
	border: 1px solid ${StyleColor.Grey50};
	margin: 7.5px;

	@media ${Format.SmartphonePortrait} {
		margin: 4.5px 0;
	}
`;
export const DriveItemVariants: ({}) = {
	[DriveItemListDisplayType.Grid]: DriveItem.extend`${ driveItemBlockStyle }`,
	[DriveItemListDisplayType.Row]: DriveItem.extend`
		position: relative;
		background: ${StyleColor.White};
		overflow: hidden;
		box-sizing: border-box;
		border-bottom: 1px solid ${StyleColor.Grey200};
		margin: 7.5px;
		border-right: 1px solid ${StyleColor.Grey200};

		@media ${Format.Smartphone} {
			margin:0;
			border-right: none;
		}
	`,
	[DriveItemListDisplayType.Masonry]: DriveItem.extend`${ driveItemBlockStyle }`
};

export const InnerDriveItemBlock = styled()(component.div, 'ImageWrapper')``;

const ImageWrapper = styled()(component.div, 'ImageWrapper')`
	position: relative;
`;
export const ImageWrapperVariants: ({}) = {
	[DriveItemListDisplayType.Grid]: ImageWrapper.extend`
		:before{
			display: block;
			content: "";
			padding-top: 66.7%; /* force 3:2 ratio */
		}
	`,
	[DriveItemListDisplayType.Masonry]: ImageWrapper.extend`
		margin-bottom: -4px;
	`
};

export const SvgWrapper = styled()(component.div, 'SvgWrapper')`
	position: relative;

	:before{
		display: block;
		content: "";
		padding-top: 66.7%; /* force 3:2 ratio */
		background-color: ${StyleColor.Grey100};
	}

	& > svg {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 60%;
		height: 60%;
		fill: ${StyleColor.Grey500};
	}
`;

export const Image = styled()(component.img, 'Image')`
	width: 100%;
	min-height: 35px;
	height: auto;
`;

interface BackgroundImageProps {
	src: string;
}

export const BackgroundImage = styled<BackgroundImageProps>()(component.div, 'BackgroundImage')`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-image: url("${props => props.src}");
	background-size: cover;
    background-position: 50% 50%;
`;

export const Footer = styled()(component.div, 'Footer')`
	border-top: 1px solid ${StyleColor.Grey50};
	background: ${props => props.theme.primary.cardColor};
	color: ${props => props.theme.primary.contentColor};
	word-break: break-all;
	display: flex;
	align-items: center;
	padding: 18px 10px 18px 15px;
	fill: ${props => props.theme.primary.iconsColor};
`;

const Label = styled()(component.div, 'Label')``;
const labelStyle = `
	flex-grow: 1;
	margin-right: 5px;
`;
export const LabelVariants: ({}) = {
	[DriveItemListDisplayType.Grid]: Label.extend`
		${ labelStyle }
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	`,
	[DriveItemListDisplayType.Masonry]: Label.extend`${ labelStyle }`
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/styles.ts